import { Vue, Component, toNative } from 'vue-facing-decorator';
import CategoryTable from 'components/Themes/CategoryTable';
import { useRouter } from 'vue-router';
import Template from './template.vue';

@Component({
	components: {
		CategoryTable,
	},
	mixins: [Template],
})
class Category extends Vue {
	private router = useRouter();

	protected showModal(): void {
		this.$root?.$emit(
			'bv::show::modal',
			'category-modal',
			'#categoryShow',
		);
	}

	protected showImport(): void {
		this.$root?.$emit(
			'bv::show::modal',
			'import-modal',
			'#importShow',
		);
	}

	protected routeCategory(id: string): void {
		this.router.push(`/themecategory/${id}`);
	}

	protected openInNewTab(id: string): void {
		const route = this.router.resolve({ name: 'EditCategory', params: { id } });
		window.open(
			route.href,
			'_blank',
		);
	}
}

export default toNative(Category);
